import React from 'react';
import MainLayout from '../layouts/MainLayout';

const AnaliseRCA = () => {
  const fiveWhysData = [
    { level: 1, question: "Por que ocorreu vazamento na vedação?", answer: "Porque o o-ring apresentou deformação após a montagem." },
    { level: 2, question: "Por que o o-ring apresentou deformação?", answer: "Porque o torque aplicado nos parafusos foi excessivo." },
    { level: 3, question: "Por que foi aplicado torque excessivo?", answer: "Porque a ferramenta de torque não estava calibrada corretamente." },
    { level: 4, question: "Por que a ferramenta não estava calibrada?", answer: "Porque o cronograma de calibração não foi seguido." },
    { level: 5, question: "Por que o cronograma não foi seguido?", answer: "Porque não existe um sistema de alerta para verificação de ferramentas com calibração vencida." }
  ];

  return (
    <MainLayout>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold">Análise 5 Porquês</h2>
          <p className="text-gray-600">Ocorrência: <span className="font-medium">OC-2025-0489</span> - Válvula de Controle A-370 - Vazamento na vedação</p>
        </div>
        <div className="flex space-x-2">
          <button className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded flex items-center">
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"></path>
            </svg>
            Salvar Rascunho
          </button>
          <button className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded flex items-center">
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            Concluir Análise
          </button>
        </div>
      </div>
      
      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-4 border-b">
          <h3 className="text-lg font-semibold">Detalhes da Ocorrência</h3>
        </div>
        <div className="p-4 grid grid-cols-3 gap-4">
          <div>
            <p className="text-sm text-gray-600 mb-1">Produto</p>
            <p className="font-medium">Válvula de Controle A-370</p>
          </div>
          <div>
            <p className="text-sm text-gray-600 mb-1">Defeito</p>
            <p className="font-medium">Vazamento na vedação</p>
          </div>
          <div>
            <p className="text-sm text-gray-600 mb-1">Severidade</p>
            <p className="font-medium">
              <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">4 - Alta</span>
            </p>
          </div>
        </div>
      </div>
      
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b flex justify-between items-center">
          <h3 className="text-lg font-semibold">Análise 5 Porquês</h3>
          <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">Em progresso - Nível 5</span>
        </div>
        <div className="p-4">
          {fiveWhysData.map((item, index) => (
            <div key={index} className="mb-6 last:mb-0">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-800 font-bold mr-4">
                  {item.level}
                </div>
                <div className="flex-grow">
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Pergunta</label>
                    <input 
                      type="text" 
                      value={item.question} 
                      className="w-full p-2 border rounded"
                      readOnly={index < fiveWhysData.length - 1}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Resposta</label>
                    <input 
                      type="text" 
                      value={item.answer} 
                      className="w-full p-2 border rounded"
                      readOnly={index < fiveWhysData.length - 1}
                    />
                  </div>
                  
                  {index === fiveWhysData.length - 1 && (
                    <div className="mt-4 flex justify-between items-center">
                      <div className="flex space-x-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Categoria</label>
                          <select className="w-full p-2 border rounded">
                            <option>Método</option>
                            <option>Máquina</option>
                            <option>Mão-de-obra</option>
                            <option>Material</option>
                            <option>Meio ambiente</option>
                            <option>Medição</option>
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Subcategoria</label>
                          <select className="w-full p-2 border rounded">
                            <option>Procedimento</option>
                            <option>Instrução de trabalho</option>
                            <option>Frequência</option>
                            <option>Outro</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              
              {index < fiveWhysData.length - 1 && (
                <div className="ml-5 pl-5 border-l-2 border-dashed border-gray-300 h-6"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default AnaliseRCA;